import React from "react";
import "./Loader.css";

const Loader = ({ text = "LOADING..." }) => {
  const colors = ["#667eea", "#764ba2", "#f093fb"];

  return (
    <div className="loader-container">
      <div className="letters">
        {[...text].map((char, index) => (
          <span
            key={index}
            style={{
              "--color": colors[index % colors.length],
              "--delay": `${index * 0.1}s`,
            }}
          >
            {char}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Loader;
